import { navigate } from "gatsby";
import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { SafeHtmlParser } from "./SafeHtmlParser";

function LoginFormIntranet() {
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState("");

	const handleLogin = async (event) => {
		event.preventDefault();

		try {
			const response = await fetch("/.netlify/functions/authenticate", {
				method: "POST",
				body: JSON.stringify({ username, password }),
			});

			const data = await response.json();

			if (response.ok) {
				const { token, user_roles } = data;

				if (user_roles.includes("intranet")) {
					// Store token and user data
					localStorage.setItem("token", token);
					localStorage.setItem("user", JSON.stringify(data));

					// Redirect to intranet dashboard
					navigate("/intranet/dashboard");
				} else {
					setError(
						"Access denied: You do not have permission to access this area."
					);
				}
			} else {
				const errorMessage = data.message
					? data.message
							.replace(/<a\b[^>]*>(.*?)<\/a>/gi, "")
							.replace(/\?$/, "")
					: "Authentication failed.";

				setError(errorMessage.trim());
			}
		} catch (error) {
			console.error("Login error:", error);
			setError("An error occurred during login.");
		}
	};

	return (
		<Form onSubmit={handleLogin} className="contact-form text-start">
			{/* Name Field */}
			<Form.Group controlId="username" className="mb-4">
				<Form.Label className="">Username:</Form.Label>
				<Form.Control
					className="special-placeholder"
					name="username"
					type="text"
					required
					value={username}
					onChange={(e) => setUsername(e.target.value)}
					placeholder="Username"
					style={nameInputStyles}
				/>
			</Form.Group>

			{/* Email Field */}
			<Form.Group controlId="password" className="mb-4">
				<Form.Label className="">Password:</Form.Label>
				<Form.Control
					className="special-placeholder"
					name="password"
					required
					type="password"
					value={password}
					onChange={(e) => setPassword(e.target.value)}
					placeholder="*****"
					style={emailInputStyles}
				/>
			</Form.Group>

			{/* Accept Terms */}

			{/* Submit Button */}
			<Button
				style={{ borderRadius: "0px" }}
				className="w-100 py-2"
				variant="gatsby"
				type="submit"
			>
				Submit
			</Button>
			<p className="mt-4">
				<span className="calibri">
					By logging in, you confirm that you agree to our{" "}
					<a
						href="/website-terms-and-conditions"
						className="purple-link fw-bold"
					>
						Terms and Conditions.
					</a>
				</span>
			</p>
			{error && (
				<div style={{ color: "red" }}>
					<SafeHtmlParser htmlContent={error} />
				</div>
			)}
		</Form>
	);
}

export default LoginFormIntranet;

const nameInputStyles = {
	border: "none",
	borderBottom: "1px solid #562A79",
	borderRadius: 0,
	padding: "10px",
	fontSize: "16px",
	color: "#333",
};

const emailInputStyles = {
	border: "none",
	borderBottom: "1px solid #CEE4FF",
	borderRadius: 0,
	padding: "10px",
	fontSize: "16px",
	color: "#333",
};

const textareaStyles = {
	border: "1px solid #CEE4FF",
	borderRadius: "0px",
	padding: "10px",
	fontSize: "16px",
	resize: "none",
};

const checkboxStyles = {
	marginTop: "10px",
	fontSize: "14px",
};
